import { t } from '../i18n/i18n';

export const templateDefault = (companyName) =>
  `<h2 style="text-align: center;"><strong>¡${companyName} ${t(
    'WANTS_TO_MEET_YOU'
  )}!</strong></h2><p style="text-align: center;"></p><p style="text-align: center;">¡${t(
    'HELLO_CUSTOM_EMAIL'
  )}, {{firstName}} {{lastName}}!</p><p style="text-align: center;">${t(
    'HOW_DO_YOU_FEEL'
  )}</p><p style="text-align: center;">${t('CUSTOM_EMAIL_TEXT')} ${companyName} ${t(
    'CUSTOM_EMAIL_TEXT_1'
  )}.</p><p style="text-align: center;">${t(
    'CUSTOM_EMAIL_TEXT_2'
  )}.</p><p style="text-align: center;"></p>`;
